var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'sanitas-system-notification': _vm.getSystemNotificationMessage()}},[_vm._v(" "+_vm._s(_vm.getSystemNotificationMessage())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }